import FunctionDetails from "../constants/functionDescription.js";

export default class FunctionService {
    static getFunctionsByName(searchString, callback) {
      let promise = new Promise((resolve, reject) => {
          let result = [];
      for (let i = 0; i < FunctionDetails.length; i++) {
        let functionName = FunctionDetails[i].name.toLowerCase();
        if (functionName.indexOf(searchString.toLowerCase()) > -1) {
          result.push(FunctionDetails[i]);
        }
      }
      resolve({
        data: result
      });
    });
      return promise;
  };
}




// WEBPACK FOOTER //
// ./src/core/services/functionService.js